(function () {

    'use strict';

    angular.module('app').controller('AccountsPayableDetailsController', AccountsPayableDetailsController);

    AccountsPayableDetailsController.$inject = [
        '$routeParams',
        'Carrier',
        'AccountingService',
        '$timeout',
        'toastr',
        '$location',
        'AccountsPayableShipmentsTableService', 
        '$q'
    ];

    function AccountsPayableDetailsController(
        $routeParams,
        Carrier,
        AccountingService,
        $timeout,
        toastr,
        $location,
        AccountsPayableShipmentsTableService, 
        $q
    ){
        const vm = this;

        vm.id = $routeParams.id === 'add' ? null : $routeParams.id;
        vm.approve = approve; 
        vm.markAsPaid = markAsPaid;

        init();

        function init() {
            loadInvoiceData();
        }

        function loadInvoiceData(){
            vm.isFetching = true;
            $q.all(getCustomerBill()).then(data => {
                vm.isFetching = false;
                vm.data = data;
                enableDisableButtons(data);
                vm.shipmentsTable = new AccountsPayableShipmentsTableService(data.shipments || [], vm.id).tableData;
            });
        }

        function getCustomerBill(){
            const defer = $q.defer();
            AccountingService.CustomerBilling.getAccountPayableDetails(data => {
                vm.data = data; 
                defer.resolve(data);
            }, error => {
                defer.resolve(null);
            }, vm.id);
            return defer.promise;
        }

        function enableDisableButtons(data){
            vm.approvePaymentButton = 
                    (data.payableStatus == 'billed' || data.payableStatus == '"payable"' || data.payableStatus == 'closed')
                    ? true : false;
            vm.disableMarkAsPaidButton = (data.payableStatus == 'payable' || data.payableStatus == 'closed') ? true : false;
        }

        function approve() {
            vm.isApproving = true;
            AccountingService.AccountsPayable.approve((data) => {
                toastr.success('Success');
                vm.isApproving = false;
                vm.data = data;
                enableDisableButtons(data);

            }, (error) => {
                toastr.warning(error.message, "Warning");
                vm.isApproving = false;
            }, vm.id)
        };

        function markAsPaid() {
            vm.isMarkingAsPaid = true;
            AccountingService.AccountsPayable.markAsPaid((data) => {
                toastr.success('Success');
                vm.isMarkingAsPaid = false;
                vm.data = data;
                enableDisableButtons(data);
            }, (error) => {
                toastr.warning(error.message, "Warning");
                vm.isMarkingAsPaid = false;
            }, vm.id)
        };
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountsPayableDetailsController.js